import { render, staticRenderFns } from "./FilesDialog.vue?vue&type=template&id=43e809b7"
import script from "./FilesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports